import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as Routes from './models/routes.model'
import { animateScroll as scroll } from 'react-scroll'
// import Footer from './components/UI/footer/pageFooter'
import NoMatch from './view/noMatch'
// import PreviewReport from './view/creport/preview'
import { getToken, setCacheURL, clearStorage } from './utils/storage'
import { startInactivityTracking, stopInactivityTracking } from './utils/inactivityTracker'
import { getRole, getClientType } from './utils/common'
import SessionWarningModal from './components/UI/sessionWarningModal'
import { publicPath, noCheckPath } from './utils/constant'
import amplitude from './analytics'
import { useLocation } from 'react-router-dom'
import './App.sass'
import { getClient, rocketChatLogin } from './api'
import { notification } from 'antd'
import { BOT_USER_ID } from './utils/constant'

moment.locale('en', {
  week: {
    dow: 1
  }
})

const isDeeplink = (hash) => {
  const client = getClientType()
  if (client === 'app') {
    const deeplink = process.env.REACT_APP_IOS_DEEPLINk
    window.location.href = deeplink + hash
  }
}

const href = window.location.href
if (href.match('/password-reset/') && !href.match('/password-reset/verify')) {
  isDeeplink(href.split('/password-reset/')[1])
}

const isPublic = (pathname) => {
  return publicPath.find((path) => {
    const match = pathname.match(path)
    return match && match.index === 0
  })
}
const isNoCheck = (pathname) => {
  return noCheckPath.find((path) => {
    const match = pathname.match(path)
    return match && match.index === 0
  })
}

function App(props) {
  const {
    location: { pathname },
    history,
    account: { user }
  } = props

  const [ ws, setWs ] = useState(null)
  const [ showWarningModal, setShowWarningModal ] = useState(false)
  const location = useLocation()
  const rocketChatRef = useRef(null)

  const loginRetried = useRef(false)

  useEffect(() => {
    amplitude.track('Page Viewed', {
      path: location.pathname
    })
  }, [location])

  const notify = async (msg) => {
    const person = JSON.parse(localStorage.getItem('phs-user'))
    if(!person || (person.profile['flags'] && person.profile['flags']['disable_chat_notification'])) return
    const senderUsername = msg.payload && msg.payload.sender && msg.payload.sender.username
    if (senderUsername === BOT_USER_ID) {
      console.log('Skipping bot user notification')
      return
    }
    let client = { first_name: '', last_name: '' }
    if (person.role === 16) {
      const data = await getClient(msg.title.split('_')[1])
      if (data.clients) client = data.clients[0]
    }
    notification.open({
      message: person.role === 16 ? `${client.first_name} ${client.last_name}` : msg.title.split('_')[0],
      description: (
        <div
          style={{
            maxHeight: '150px'
          }}
        >
          <div>{msg.payload.sender.name}</div>
          <div style={{ maxWidth: '100%' }} dangerouslySetInnerHTML={{ __html: msg.payload.message.msg }} />
        </div>
      ),
      onClick: () => {
        if (person.role === 16) {
          history.push(`/client/${msg.title.split('_')[1]}/detail/chat`)
        } else {
          history.push('/app/chat')
        }
      },
      style: { cursor: 'pointer' }
    })
  }

  useEffect(() => {
    const initial = async () => {
      const location = history.location
      const token = getToken()
      const isPublicLink = isPublic(location.pathname)
      const isNoCheckLink = isNoCheck(location.pathname)

      let rocketChatData
      const person = JSON.parse(localStorage.getItem('phs-user'))
      if(person){
      // if(!person) return
        const res = await rocketChatLogin(person.id)
        rocketChatData = res
        localStorage.setItem('rocket-chat-data', JSON.stringify(res))
      }
      rocketChatRef.current = rocketChatData

      webSocketConnect()

      if (!token || !user) {
        if (!isPublicLink) {
          if (location.pathname !== '/') {
            setCacheURL(`${location.pathname}${location.search}`)
          }
          history.push('/sign-in')
        }
      } else if (user && !(isPublicLink || isNoCheckLink)) {
        const {
          profile: {
            onboarding_steps: { onboarding_required },
            membership_selected
          }
        } = user
        const role = getRole(user.role)
        if (
          location.pathname === '/app/setting/view-signed-forms' &&
          onboarding_required
        ) {
          history.push('/redirect-sign-waiver-form')
        } else if (role === 'User' && location.pathname !== '/2fa') {
          if (!membership_selected) {
            history.push('/membership-selection')
          } else if (onboarding_required !== false) {
            history.push('/onboarding/ready')
          }
        }
      }
    }

    initial()
  }, [])

  useEffect(() => {
    scroll.scrollToTop({ ignoreCancelEvents: true })
  }, [pathname])

  const handleSessionWarning = () => {
    setShowWarningModal(true)
  }

  const handleStayLoggedIn = () => {
    setShowWarningModal(false)
    stopInactivityTracking()
    setTimeout(() => {
      startInactivityTracking(handleSessionWarning)
    }, 100)
  }

  const handleLogoutNow = () => {
    setShowWarningModal(false)
    stopInactivityTracking()
    clearStorage()
    const origin = window.location.origin
    window.location.href = `${origin}/sign-in?reason=session_expired`
  }

  useEffect(() => {
    const token = getToken()
    if (token && user) {
      startInactivityTracking(handleSessionWarning)
    } else {
      stopInactivityTracking()
    }

    return () => {
      stopInactivityTracking()
    }
  }, [user])

  const webSocketConnect = () => {
    const ws = new WebSocket(process.env.REACT_APP_ROCKET_CHAT_WS_URL)
    setWs(ws)

    ws.onopen = () => {
      ws.send(JSON.stringify({
        msg: 'connect',
        version: '1',
        support: ['1']
      }))
    }

    ws.onclose = () => {
      setTimeout(webSocketConnect, 1000)
    }

    ws.onmessage = (event) => {
      if (!rocketChatRef.current) return
      const data = JSON.parse(event.data)

      if (data.msg === 'connected' || (data.error && !loginRetried)) {
        loginRetried.current = true
        ws.send(JSON.stringify({
          msg: 'method',
          method: 'login',
          id: '1',
          params: [{
            resume: rocketChatRef.current.authToken
          }]
        }))
      }

      if (data.msg === 'ping') {
        ws.send(JSON.stringify({ msg: 'pong' }))
      }

      if (data.msg === 'result' && data.id === '1') {
        loginRetried.current = false
        ws.send(JSON.stringify({
          msg: 'sub',
          id: 'notif-1',
          name: 'stream-notify-user',
          params: [
            `${rocketChatRef.current.userId}/notification`,
            false
          ]
        }))
      }

      if (data.msg === 'changed' && data.collection === 'stream-notify-user') {
        const msg = data.fields.args[0]
        notify(msg)
      }
    }
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      console.log('Visibility changed:', document.hidden)
      if (!document.hidden && ws && ws.current && ws.current.readyState !== WebSocket.OPEN) {
        console.log('Visible, reconnected...')
        webSocketConnect()
      }
    }

    const handleOnline = () => {
      console.log('Back online, reconnecting WebSocket...')
      if (ws && ws.current && ws.current.readyState !== WebSocket.OPEN) {
        console.log('Back online, reconnected...')
        webSocketConnect()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('online', handleOnline)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('online', handleOnline)
    }
  }, [webSocketConnect, ws])

  return (
    <div className="App">
      <div>
        <Switch>
          {/* <Route path="/creport/preview/:hash" component={PreviewReport} /> */}
          {dynamicRoutes(user && user.role).map((route, index) => (
            <Route
              exact={route.exact}
              path={route.path}
              component={route.component}
              render={route.render}
              key={index}
            />
          ))}
          {user && <Route component={NoMatch} />}
        </Switch>
        {/* <Footer {...props} /> */}
      </div>
      <SessionWarningModal
        visible={showWarningModal}
        onStayLoggedIn={handleStayLoggedIn}
        onLogoutNow={handleLogoutNow}
        countdownSeconds={300}
      />
    </div>
  )

  function dynamicRoutes(roleNumber) {
    if (!roleNumber) return Routes.commonRoutes
    const role = getRole(roleNumber)
    let routes = Routes.commonRoutes
    switch (role) {
      case 'Expert':
      case 'Coach':
      case 'InternalAdmin':
      case 'Manager':
        routes = routes.concat(Routes.coachRoutes)
        break
      case 'Service_Provider':
        routes = routes.concat(Routes.providerRoutes)
        break
      case 'Assistant':
      case 'User':
        routes = routes.concat(Routes.clientRoutes)
        break
      default:
        break
    }
    return routes
  }
}

export default withRouter(connect(({ account }) => ({ account }), null)(App))
